import { AWSUser, UserAttrs } from './types';

export function toUserAttrs(user: AWSUser): UserAttrs {
  return user.Attributes.reduce((result, attr) => {
    return { ...result, [attr.Name]: attr.Value };
  }, {}) as UserAttrs;
}
